import { render, staticRenderFns } from "./CascadingPermissionsProfilesEditForm.vue?vue&type=template&id=2e4ad8c0"
import script from "./CascadingPermissionsProfilesEditForm.vue?vue&type=script&lang=js"
export * from "./CascadingPermissionsProfilesEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports